module.exports = __webpack_public_path__ + "media/images/results_arrow-addee17ef559bf4397918a239ab5ddd0.svg";